import { useState } from 'react';
import { RevealBox, SectionLabel, SectionTitle, SectionSub } from './UI';
import amityLogo from '../assets/amity.png';
import chandigarhLogo from '../assets/chandigraghuni.png';
import dyLogo from '../assets/dy.png';
import manipalLogo from '../assets/mit.png';
import nmimsLogo from '../assets/nmims.png';
import bharatilogo from '../assets/bharatilogo.png';

const programs = ['All', 'MBA', 'MCA', 'BBA', 'MA/MCom', 'Diploma'];

const universities = [
  {
    name: 'Amity University',
    badge: 'NAAC A++',
    rating: '4.9',
    desc: 'India\'s most prestigious private university — internationally recognised in 180+ countries with world-class faculty and robust alumni network of 2,00,000+.',
    tags: ['MBA', 'MCA', 'MA', 'MCom', 'BBA', 'BCA'],
    highlight: 'Ranked #1 Private University',
    color: '#1a3a8f',
    logo: amityLogo,
  },
  {
    name: 'Dr. DY Patil University',
    badge: 'NAAC A++',
    rating: '4.8',
    desc: 'Pune\'s premier institution with cutting-edge online programs, strong industry ties, and exceptional placement records across management and technology.',
    tags: ['MBA', 'MCA', 'BBA', 'BCA'],
    highlight: 'Top-Ranked in Maharashtra',
    color: '#7b1f2e',
    logo: dyLogo,
  },
  {
    name: 'NMIMS University',
    badge: 'NAAC A+',
    rating: '4.8',
    desc: 'One of India\'s most respected management institutions, offering industry-aligned programs designed for real-world leadership and career acceleration.',
    tags: ['MBA', 'BBA', 'MA', 'MCom'],
    highlight: 'Premier Management Institute',
    color: '#1a5c3a',
    logo: nmimsLogo,
  },
  {
    name: 'Manipal University',
    badge: 'NAAC A++',
    rating: '4.7',
    desc: 'A globally connected institution with 300,000+ alumni worldwide. Offers flexible online programs with the credibility of a 70-year academic legacy.',
    tags: ['MBA', 'MCA', 'BBA', 'BCA', 'MA'],
    highlight: 'Global Alumni Network',
    color: '#5c3a1a',
    logo: manipalLogo,
  },
  {
    name: 'Chandigarh University',
    badge: 'NAAC A+',
    rating: '4.7',
    desc: 'QS World Ranked university known for its innovation-driven curriculum, 900+ industry partnerships, and highest placement packages in North India.',
    tags: ['MBA', 'MCA', 'BBA', 'BCA', 'MA', 'MCom'],
    highlight: 'QS World Ranked',
    color: '#2a1a5c',
    logo: chandigarhLogo,
  },
  {
  name: 'Bharati Vidyapeeth University',
  badge: 'NAAC A+',
  rating: '4.7',
  desc: 'A UGC-approved deemed-to-be university offering industry-oriented online and distance learning programs with experienced faculty, flexible learning, and strong academic excellence across management, IT, and commerce.',
  tags: ['MBA', 'MCA', 'BBA', 'BCA', 'MA', 'MCom'],
  highlight: 'UGC-DEB Approved',
  color: '#8B0000',
  logo: bharatilogo,
},
  {
    name: 'Professional Certifications',
    badge: 'Industry-Endorsed',
    rating: '4.9',
    desc: 'Fast-track diploma, certificate, and skill development courses in IT, Management, Finance, Digital Marketing, Data Analytics and more.',
    tags: ['Diploma', 'MA/MCom'],
    highlight: 'Job-Ready in Weeks',
    color: '#1a4a3a',
    logo: null,
  },
];

export default function Universities() {
  const [filter, setFilter] = useState('All');
  const [hovered, setHovered] = useState(null);

  const filtered = filter === 'All'
    ? universities
    : universities.filter(u => u.tags.some(t => t.startsWith(filter)));

  return (
    <section id="universities" style={{ padding: '100px 6%', background: 'var(--offwhite)' }}>
      <RevealBox style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', flexWrap: 'wrap', gap: 24 }}>
        <div>
          <SectionLabel>University Partners</SectionLabel>
          <SectionTitle>Top-Ranked <em style={{ fontStyle: 'italic' }}>University Partners</em></SectionTitle>
          <SectionSub>We exclusively partner with NAAC-accredited, UGC-DEB approved institutions. No compromises.</SectionSub>
        </div>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          {programs.map(p => (
            <button key={p} onClick={() => setFilter(p)} style={{
              padding: '8px 18px', borderRadius: 999, fontSize: 13, fontWeight: 600, cursor: 'pointer',
              background: filter === p ? 'var(--navy)' : 'var(--white)',
              color: filter === p ? 'var(--yellow)' : 'var(--gray)',
              border: `1.5px solid ${filter === p ? 'var(--navy)' : 'var(--graylt)'}`,
              transition: 'all 0.2s',
            }}>{p}</button>
          ))}
        </div>
      </RevealBox>

      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
        gap: 20, marginTop: 44,
      }}>
        {filtered.map((u, i) => (
          <RevealBox key={u.name} delay={i * 0.07}>
            <div
              onMouseEnter={() => setHovered(u.name)}
              onMouseLeave={() => setHovered(null)}
              style={{
                background: 'var(--white)', border: '1.5px solid var(--graylt)',
                borderRadius: 'var(--radius)', overflow: 'hidden',
                transition: 'all 0.35s cubic-bezier(0.22,1,0.36,1)',
                transform: hovered === u.name ? 'translateY(-6px)' : 'translateY(0)',
                boxShadow: hovered === u.name ? 'var(--shadow-lg)' : 'var(--shadow)',
              }}
            >
              {/* Color bar */}
              <div style={{ height: 6, background: u.color }} />

              <div style={{ padding: '24px 24px 22px' }}>

                {/* Logo + badge row */}
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 16 }}>

                  {/* Logo */}
                  {u.logo ? (
                    <div
                      style={{
                        width: 140,
                        height: 100,
                        background: "#fff",
                        border: "1px solid var(--graylt)",
                        borderRadius: 12,
                        padding: "10px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexShrink: 0,
                        overflow: "hidden",
                      }}
                    >
                      <img
                        src={u.logo}
                        alt={`${u.name} logo`}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "contain",
                        }}
                      />
                    </div>
                  ) : (
                    <div
                      style={{
                        width: 130,
                        height: 90,
                        borderRadius: 12,
                        background: u.color,
                        display: "grid",
                        placeItems: "center",
                        fontSize: 30,
                        color: "#fff",
                        flexShrink: 0,
                      }}
                    >
                      ⚡
                    </div>
                  )}
                  {/* Badge + rating */}
                  <div style={{ textAlign: 'right' }}>
                    <div style={{
                      background: 'var(--navy)', color: 'var(--yellow)',
                      fontSize: 10, fontWeight: 800, padding: '4px 10px', borderRadius: 999,
                      letterSpacing: '0.5px', display: 'inline-block', marginBottom: 6,
                    }}>{u.badge}</div>
                    <div style={{
                      display: 'flex', alignItems: 'center', gap: 4, justifyContent: 'flex-end',
                      color: 'var(--gray)', fontSize: 12, fontWeight: 600,
                    }}>⭐ {u.rating}</div>
                  </div>
                </div>

                {/* Name */}
                <h3 style={{ fontSize: 19, color: 'var(--navy)', marginBottom: 8 }}>{u.name}</h3>

                {/* Highlight */}
                <div style={{
                  display: 'inline-block', background: 'var(--yellow3)',
                  color: 'var(--navy)', fontSize: 11, fontWeight: 700,
                  padding: '4px 12px', borderRadius: 6, marginBottom: 12,
                }}>{u.highlight}</div>

                {/* Desc */}
                <p style={{ fontSize: 13.5, color: 'var(--gray)', lineHeight: 1.65, marginBottom: 18 }}>{u.desc}</p>

                {/* Tags */}
                <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 18 }}>
                  {u.tags.map(t => (
                    <span key={t} style={{
                      fontSize: 11, background: 'var(--offwhite)', color: 'var(--navy2)',
                      padding: '4px 12px', borderRadius: 6,
                      border: '1px solid var(--graylt)', fontWeight: 600,
                    }}>{t}</span>
                  ))}
                </div>

                {/* CTA */}
                <a href="#contact" style={{
                  display: 'block', textAlign: 'center', padding: '12px',
                  background: hovered === u.name ? 'var(--navy)' : 'var(--white)',
                  color: hovered === u.name ? 'var(--yellow)' : 'var(--navy)',
                  border: '1.5px solid var(--graylt)', borderRadius: 8,
                  fontSize: 13, fontWeight: 700, transition: 'all 0.25s',
                }}>Enquire Now →</a>
              </div>
            </div>
          </RevealBox>
        ))}
      </div>
    </section>
  );
}